// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton_button__1sCUZ","tooltip":"IconButton_tooltip__35Emc"};